<template>
    <div>
        <div class="comment">
            <!-- eslint-disable vue/no-v-html -->
            <div class="px-sm mr-sm" v-html="comment.user.big_avatar" />
            <div>
                <a
                    v-if="canSeeProfile"
                    :href="user_url"
                    class="text-sm font-semibold"
                >
                    {{ comment.user.name }}
                </a>
                <span v-else>
                    {{ comment.user.name }}
                </span>
                <p class="comment__posted_at">
                    {{ posted_at }}
                </p>

                <!-- eslint-disable vue/no-v-html -->
                <p class="comment__body" v-html="comment.body_formatted" />
            </div>
        </div>

        <hr class="mb-xl">
    </div>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            comment: {
                required: true,
                type: Object,
            },
        },

        computed: {
            user_url() {
                return `/users/${this.comment.user.id}`;
            },
            posted_at() {
                return format(
                    this.comment.created_at,
                    'YYYY-MM-DD [  kl. ] HH:mm',
                );
            },
            canSeeProfile() {
                return has_permission('viewProfiles');
            },
        },
    };
</script>